import { Component, inject, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarDataModel } from '@alf-nx-workspace/shared/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EbenTaskDetail } from '@alf-nx-workspace/eben/interfaces';

@Component({
  selector: 'shared-ui-snackbar',
  templateUrl: './task-completed-snackbar.component.html',
  styleUrls: ['./task-completed-snackbar.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule, MatButtonModule, MatProgressBarModule]
})
export class TaskCompletedSnackbar {

  snackBarRef = inject(MatSnackBarRef);

  duration: number;
  showProgressBar = false;
  progressValue = 0;

  title = 'SNACKBAR.TASK_COMPLETED.TITLE';
  task: EbenTaskDetail;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarDataModel) {
    this.duration = data.duration;
    this.task = data.task as unknown as EbenTaskDetail;
  }

  ngOnInit() {
    this.showProgressForDuration();
  }

  private showProgressForDuration() {
    this.showProgressBar = true;
    this.progressValue = 100;

    const steps = this.duration / 100;
    const decrement = 100 / steps;

    const interval = setInterval(() => {
      this.progressValue -= decrement;
      if (this.progressValue <= 0) {
        this.progressValue = 0;
        clearInterval(interval);
        this.showProgressBar = false;
      }
    }, 100);
  }
}
